import AdminChemicalComponent from "@/admin-pages/Components"
import { ContactInfoList } from "@/admin-pages/ContactInfoList/ContactInfoList"
import { EquipmentMenus } from "@/admin-pages/EquipmentMenus/EquipmentMenus"
import { EquipmentList } from "@/admin-pages/Equipments/EquipmentList"
import { EquipmentBasic } from "@/admin-pages/Equipments/Item/Basic/EquipmentBasic"
import { EquipmentItem } from "@/admin-pages/Equipments/Item/EquipmentItem"
import { GraphDesign } from "@/admin-pages/Equipments/Item/GraphDesign/GraphDesign"
import { NozzleShapes } from "@/admin-pages/NozzleShape"
import { PlanPermissions } from "@/admin-pages/PlanPermissions/PlanPermissions"
import { PlanSetting } from "@/admin-pages/PlanSetting/PlanSetting"
import { CreatePropertySet } from "@/admin-pages/PropertySets/Create/CreatePropertySet"
import { PropertySetBasic } from "@/admin-pages/PropertySets/Item/Basic/PropertySetBasic"
import { PropertySetComponents } from "@/admin-pages/PropertySets/Item/Components/PropertySetComponents"
import { PropertySet } from "@/admin-pages/PropertySets/Item/PropertySet"
import { PropertySetReactionSets } from "@/admin-pages/PropertySets/Item/ReactionSets/PropertySetReactionSets"
import { PropertySetReactions } from "@/admin-pages/PropertySets/Item/Reactions/PropertySetReactions"
import { PropertySets } from "@/admin-pages/PropertySets/PropertySets"
import { SubscriptionList } from "@/admin-pages/SubscriptionList/SubscriptionList"
import AdminLayout from "@/layouts/AdminLayout"
import DimensionItem from "@/pages/Dimension/Item"
import DimensionList from "@/pages/Dimension/List"

import { Navigate, Outlet } from "react-router"

export const adminRoutes = {
  path: 'admin',
  element: <AdminLayout />,
  children: [
    {
      path: '',
      element: <Navigate to='dimension' />
    },
    {
      path: 'dimension',
      element: <Outlet />,
      children: [
        { path: '', element: <DimensionList /> },
        { path: 'create', element: <DimensionItem /> },
        { path: ':id', element: <DimensionItem /> }
      ]
    },
    {
      path: 'components',
      element: <Outlet />,
      children: [{ path: '', element: <AdminChemicalComponent /> }]
    },
    {
      path: 'property-sets',
      element: <Outlet />,
      children: [
        { path: '', element: <PropertySets /> },
        { path: 'create', element: <CreatePropertySet /> },
        { 
          path: ':id', element: <PropertySet />, children: [
            { path: '', element: <Navigate to='basic' /> },
            { path: 'basic', element: <PropertySetBasic /> },
            { path: 'components', element: <PropertySetComponents /> },
            { path: 'reactions', element: <PropertySetReactions /> },
            { path: 'reaction-sets', element: <PropertySetReactionSets /> },
          ]
        },
      ]
    },
    {
      path: 'equipment',
      element: <Outlet />,
      children: [
        { path: '', element: <EquipmentList /> },
        {
          path: ':id', element: <EquipmentItem />, children: [
            { path: '', element: <Navigate to='basic' /> },
            { path: 'basic', element: <EquipmentBasic /> },
            { path: 'graph-design', element: <GraphDesign /> },
          ]
        },
      ]
    },
    {
      path: 'nozzle-shapes',
      element: <Outlet />,
      children: [
        { path: '', element: <NozzleShapes /> },
      ]
    },
    {
      path: 'palette-containers',
      element: <Outlet />,
      children: [
        { path: '', element: <EquipmentMenus /> },
      ]
    },
    {
      path: 'contact-info',
      element: <Outlet />,
      children: [
        { path: '', element: <ContactInfoList /> },
      ]
    },
    {
      path: 'subscription',
      element: <Outlet />,
      children: [
        { path: '', element: <SubscriptionList /> },
      ]
    },
    {
      path: 'plan-permissions',
      element: <Outlet />,
      children: [
        { path: '', element: <PlanPermissions /> },
      ]
    },
    {
      path: 'plan-setting',
      element: <Outlet />,
      children: [
        { path: '', element: <PlanSetting /> },
      ]
    },
  ]
}